import { useState } from "react";
import { api, SITE_HOST } from "../api";
import { Logo } from "../components/Logo";
import { Footer } from "../components/Footer";

export function Reset({ token }: { token: string }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (password.length < 8) {
      setErr("Parola en az 8 karakter olmalı.");
      return;
    }
    if (password !== confirm) {
      setErr("Parolalar eşleşmiyor.");
      return;
    }
    setBusy(true);
    try {
      await api.confirmPasswordReset(token, password);
      setDone(true);
    } catch (e) {
      const code = e instanceof Error ? e.message : "reset_failed";
      setErr(
        code === "invalid_token"
          ? "Bağlantı geçersiz veya süresi dolmuş. Yeni bir sıfırlama isteyin."
          : code === "weak_password"
            ? "Parola en az 8 karakter olmalı."
            : "Sıfırlanamadı, tekrar deneyin.",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">
          <Logo size={40} withDot={done} title={SITE_HOST} />
          <div>
            <h1>Portal</h1>
            <div className="muted">{SITE_HOST}</div>
          </div>
        </div>
        {done ? (
          <>
            <h2 style={{ marginTop: 8 }}>Parola güncellendi</h2>
            <p className="muted">Yeni parolanızla giriş yapabilirsiniz.</p>
            <div style={{ marginTop: 16 }}>
              <a href="/">Giriş sayfasına git</a>
            </div>
          </>
        ) : (
          <form onSubmit={submit}>
            <p className="muted">En az 8 karakterli yeni bir parola belirleyin.</p>
            <label>Yeni parola</label>
            <input
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
            />
            <label>Parola (tekrar)</label>
            <input
              type="password"
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              minLength={8}
            />
            <div style={{ marginTop: 16 }}>
              <button type="submit" disabled={busy} style={{ width: "100%" }}>
                {busy ? "Kaydediliyor…" : "Parolayı kaydet"}
              </button>
            </div>
            {err && <div className="error">{err}</div>}
          </form>
        )}
      </div>
    </div>
      <Footer />
    </>
  );
}
